import { SeoMetaTypeEnum } from '@is24at/react-enums';
import seoRules from 'core/seoRules';

const description = ({ searchQuery }: any) =>
  seoRules.lookupAndFormatFor(SeoMetaTypeEnum.META_DESCRIPTION, searchQuery);

export default description;
